import React from "react";

const Greeting = props => {
	const getTextToShow = () => {
		return <h2 className="sub-heading">{`Hi ${props.user.greetingName ? `${props.user.greetingName},` : ""}`}</h2>;
	};

	return getTextToShow();
};

export default Greeting;
